import {inject} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, Router} from '@angular/router';
import {BaseProductConfig, PRODUCT_CONFIG_TOKEN} from '@scalified-monorepo/ng-shared';
import {map, take} from 'rxjs/operators';
import {AuthStore} from '../ngrx/auth.store';
import {isAuthenticatedIdentity} from '../utils/identity.utils';

export const getAnonymousGuard =
  (redirectUrl?: string): CanActivateFn =>
  (route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const productConfig: BaseProductConfig = inject(PRODUCT_CONFIG_TOKEN);
    if (!redirectUrl) redirectUrl = productConfig.initialProtectedRoute;
    const identity$ = toObservable(authStore.identity);
    return identity$.pipe(
      take(1),
      map(identity => {
        if (isAuthenticatedIdentity(identity)) {
          console.info(`Authenticated, redirecting to ${redirectUrl}`);
          return router.createUrlTree([redirectUrl]);
        }
        return true;
      })
    );
  };
